import { UserCircleIcon,MenuAlt3Icon } from "@heroicons/react/solid";
import React, { useState } from "react";
import { Link } from "react-router-dom";
import './Sidebar.css';

export default function Sidebar() {
  const [isOpen, setIsOpen] = useState(true);

  return (
    <>
      <header>
        <nav className="top-0 bg-secondary">
          <ul className="flex items-center justify-between px-4 py-3 text-white">
            <li>
              <button
                id="sidebar-toggle"
                className="px-4 py-3 text-white hover:text-gray-300"
                onClick={() => setIsOpen(!isOpen)}
              >
                <MenuAlt3Icon className="w-8 h-8" />
              </button>
            </li>
            <li>
              <div className="font-bold transition-all duration-300 logo hover:text-gray-600">
                <Link to="/">Geulanggang-Panah</Link>
              </div>
            </li>
            <li>
              <Link to="/">
                <UserCircleIcon className="w-8 h-8 text-green" />
              </Link>
            </li>
          </ul>
        </nav>
      </header>

      <main className="flex">
        <aside
          className={`bg-sibarColor h-screen w-64 text-sm ${
            isOpen ? "sidebar-open" : "sidebar-closed"
          }`}
        >
          <ul className="px-2 py-4">
            <li>
              <div className="block px-4 py-2 text-white rounded-lg cursor-pointer hover:bg-gray-800">
                <Link to="/">Geulanggang-Panah</Link>
              </div>
            </li>
          </ul>
        </aside>
        <div className={`flex bg-fuchsia-200 ${isOpen ? "" : "min-w-full"}`}>
          Lorem ipsum dolor, sit amet consectetur adipisicing elit. Eaque optio
          earum perspiciatis facilis odit asperiores ipsam, sit esse rerum culpa
          eum voluptatem delectus, quae distinctio totam nobis minima explicabo
          corporis?
        </div>
      </main>
    </>
  );
}
